import { useState } from 'react';
import { CreditCard, Package, DollarSign } from 'lucide-react';
import { PlansTab } from '../components/PlansTab';
import { ModulesTab } from '../components/ModulesTab';

type TabType = 'plans' | 'modules';

const TABS = [
  { id: 'plans' as const, label: 'Plans', icon: CreditCard },
  { id: 'modules' as const, label: 'Premium Modules', icon: Package },
];

export function BillingPage() {
  const [activeTab, setActiveTab] = useState<TabType>('plans');

  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <h1 className="text-2xl font-bold text-theme">Billing Management</h1>
        <p className="mt-1 text-theme-secondary">
          Manage subscription plans and premium modules
        </p>
      </div>

      {/* Tabs */}
      <div className="border-b border-theme">
        <nav className="flex gap-8">
          {TABS.map((tab) => {
            const Icon = tab.icon;
            const isActive = activeTab === tab.id;
            return (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`
                  flex items-center gap-2 pb-4 px-1 border-b-2 font-medium text-sm transition-colors
                  ${isActive
                    ? 'border-indigo-600 text-indigo-600'
                    : 'border-transparent text-theme-secondary hover:text-theme hover:border-slate-300'
                  }
                `}
              >
                <Icon className="w-4 h-4" />
                {tab.label}
              </button>
            );
          })}
        </nav>
      </div>

      {/* Tab Content */}
      {activeTab === 'plans' && <PlansTab />}
      {activeTab === 'modules' && <ModulesTab />}
    </div>
  );
}
